// extracted by mini-css-extract-plugin
export default {"partnersList":"Partners_partnersList__iWYXy"};